import config from '../../config/config';

export const USER_MESSAGE_SESSION_KEY = 'riv779UserMessageSeen';

export function hasSeenUserMessageThisSession() {
    try {
        return window.sessionStorage.getItem(USER_MESSAGE_SESSION_KEY) === '1';
    } catch (error) {
        return false;
    }
}

export function markUserMessageSeenThisSession() {
    try {
        window.sessionStorage.setItem(USER_MESSAGE_SESSION_KEY, '1');
    } catch (error) {
        // sessionStorage can throw in private browsing
    }
}

export function clearUserMessageSession() {
    try {
        window.sessionStorage.removeItem(USER_MESSAGE_SESSION_KEY);
    } catch (error) {
        // sessionStorage can throw in private browsing
    }
}

export function openSearch(history) {
    history.push('/search/all');
}

export function updateLastLogin() {
    return {
        failureActionTypeOrCreator: (error) => {
            return { error, type: 'failed' };
        },
        fetchParams: {
            method: 'POST',
            url: `${config.userManagementApiUrl}/updateLastLogin`
        },
        successActionTypeOrCreator: () => {
            return { type: 'succeded' };
        }
    };
}
